// extracted by mini-css-extract-plugin
export default {"img":"Profile_img__lGQN-","innerImg":"Profile_innerImg__VeYPD","body":"Profile_body__v2ZCW","imgMemb":"Profile_imgMemb__vyGau"};